import { render, staticRenderFns } from "./stdBranch.vue?vue&type=template&id=560b5732&scoped=true&"
import script from "./stdBranch.vue?vue&type=script&lang=js&"
export * from "./stdBranch.vue?vue&type=script&lang=js&"
import style0 from "./stdBranch.vue?vue&type=style&index=0&id=560b5732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560b5732",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
